import React from 'react';
import '../../styles/Objects.css';

interface ObjectFloatProps {
  /** basename in public/images/objects, e.g. "espresso" */
  slug: string;
  className?: string;
}

/**
 * A static desk object drifting on the site's shared float keyframes.
 * Purely decorative: hidden from assistive tech, inert to the pointer,
 * lazy-loaded (every placement sits below the fold except the hero, which
 * uses AlphaLoop instead).
 */
const ObjectFloat: React.FC<ObjectFloatProps> = ({ slug, className = '' }) => (
  <img
    src={`/images/objects/${slug}.webp`}
    alt=""
    aria-hidden="true"
    width={800}
    height={800}
    loading="lazy"
    decoding="async"
    draggable={false}
    className={`obj obj-float ${className}`}
  />
);

export default ObjectFloat;
